<template>
  <breadCrumbs title="Recent Orders" main="Ecommerce" title1="Recent Orders" />

  <div class="container-fluid">
    <div class="row">
      <div class="col-sm-12">
        <div class="card">
          <div class="card-header pb-0">
            <h3>Order history</h3>
          </div>
          <div class="card-body">
            <div class="order-history table-responsive">
              <table class="table display dataTable" id="basic-1">
                <thead>
                  <tr>
                    <th scope="col" class="text-center">Product</th>
                    <th scope="col">Product name</th>
                    <th scope="col">Size</th>
                    <th scope="col">Color</th>
                    <th scope="col">Article number</th>
                    <th scope="col">Units</th>
                    <th scope="col">Price</th>
                    <th scope="col"><i class="fa fa-angle-down"></i></th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(item, index) in data" :key="index">
                    <td class="text-center"><router-link :to="'/ecommerce/product/page/1'"><img class="img-fluid img-30"
                          :src="getImgUrl(item.img)" alt="#"></router-link></td>
                    <td>
                      <div class="product-name"><a href="javascript:void(0)">{{ item.product }}</a>
                        <div class="order-process"><span class="order-process-circle"></span>{{ item.prdouctstatus }}</div>
                      </div>
                    </td>
                    <td>{{ item.size }}</td>
                    <td>{{ item.color }}</td>
                    <td>{{ item.articleno }}</td>
                    <td>{{ item.units }}</td>
                    <td>{{ item.price }}</td>
                    <td><vue-feather type="more-vertical"></vue-feather></td>
                  </tr>

                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import order from '../../../../data/orderhistory.json'
export default {
  name: 'orderHistory',
  data() {
    return {
      data: order.data
    }
  },
  methods: {
    getImgUrl(path) {
      return require("../../../../assets/images/" + path);
    },
  }
}
</script>
